import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import Navbar from './Navbar';

const MainLayout = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const location = useLocation();

  // Close off-canvas sidebar on route change; remember the previous route (used for filter carry-over)
  useEffect(() => {
    setSidebarOpen(false);
    const current = sessionStorage.getItem('tms_current_path');
    if (current && current !== location.pathname) sessionStorage.setItem('tms_prev_path', current);
    sessionStorage.setItem('tms_current_path', location.pathname);
  }, [location.pathname]);

  return (
    <div className={`nui-wrapper ${sidebarOpen ? 'sidebar-open' : ''}`}>
      <Sidebar />
      {sidebarOpen && <div className="nui-overlay" onClick={() => setSidebarOpen(false)} data-testid="sidebar-overlay" />}
      <div className="nui-page-wrapper">
        <Navbar onToggleSidebar={() => setSidebarOpen((o) => !o)} sidebarOpen={sidebarOpen} />
        <main className="nui-page-content">{children}</main>
      </div>
    </div>
  );
};

export default MainLayout;
